import { RLCard } from "../../../../../../components";

import {
  useGetReportSummary,
  useLocalSampleSummaryParams
} from "../../../../hooks";

import { COMPONENT_IDS } from "../../../../consts";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { PDFExport } from "../../@types/PDFExport";
import { Tooltip } from "../common";
import { Story } from "./components";

type Props = PDFExport;

const SampleDescriptionCard = ({ isPdfView }: Props) => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data } = useGetReportSummary(hash, sourceId, relationshipId);

  return (
    <RLCard
      header={
        <RLCard.Header>
          <Tooltip
            message={DESCRIPTIONS[COMPONENT_IDS.SAMPLE_DESCRIPTION]}
            placement="top"
          >
            <span>Sample Description</span>
          </Tooltip>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          <Story story={data?.story} isPdfView={isPdfView} />
        </RLCard.Content>
      }
      data-testid="report_summary_sample_description_card"
    />
  );
};

export default SampleDescriptionCard;
